var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-flex",attrs:{"href":_vm.isLogged ? '/' + _vm.lang + '/area-utente/dashboard' : '/' + _vm.lang + '/register'},on:{"click":_vm.toggleLogin}},[_c('img',{attrs:{"src":'/images/user-' + _vm.theme + '.svg',"alt":"icona"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }